import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@r8er/components/ui/select";
import { classes } from "@r8er/lib/utils";
import { InputHTMLAttributes, useState } from "react";
import styles from "./Input.module.css";
import { OnInputChangeCB } from "./onChange";

interface OptionProps extends InputHTMLAttributes<HTMLOptionElement> {
  label: string;
  value: string;
}

export interface InputSelectProps
  extends Omit<
    InputHTMLAttributes<HTMLSelectElement>,
    "onChange" | "defaultChecked" | "type"
  > {
  id: string;
  defaultValue?: InputHTMLAttributes<HTMLSelectElement>["defaultValue"];

  onChange?: OnInputChangeCB;

  options: OptionProps[];

  theme?: {
    selectContainer?: string;
    selectButton?: string;
    selectedOption?: string;
    selectedOptionButton?: string;
    unselectedOption?: string;
    arrowDown?: string;
    selectOptions?: string;
    selectOptionsContent?: string;
    visibleSelectOptions?: string;
    selectOption?: string;
    selectedOptionContainer?: string;
    activeButton?: string;
    activeContainer?: string;
  };
}

export const InputSelect = ({
  id,
  name,
  defaultValue,
  onChange,
  options,
  theme,
  ...props
}: InputSelectProps) => {
  const [oldValue, setOldValue] = useState(defaultValue);
  return (
    <Select
      name={name}
      defaultValue={defaultValue?.toString()}
      onValueChange={(newValue) => {
        if (onChange)
          onChange({
            event: undefined,
            newValue,
            oldValue,
          });
        setOldValue(newValue);
      }}
    >
      <SelectTrigger
        className={classes(
          styles.selectContainer,
          theme?.selectContainer,
          styles.selectButton,
          theme?.selectButton
        )}
      >
        <SelectValue placeholder="Select..." />
      </SelectTrigger>
      <SelectContent
        collisionPadding={{
          top: 210,
          bottom: 10,
        }}
        className={classes(
          styles.selectOptions,
          theme?.selectOptions,
          styles.selectOptionsContent,
          theme?.selectOptionsContent
        )}
      >
        {options.map((option) => (
          <SelectItem
            className={classes(styles.selectOption, theme?.selectOption)}
            value={option.value}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
